import { CSSProperties } from 'react';

/**
 * HostNote — gold-tinted card with host avatar and a serif personal quote.
 * Shown at the top of trip handbooks and section intros. Quote marks auto-added.
 */
export interface HostNoteProps {
  hostName: string;
  /** Quote text WITHOUT surrounding quotation marks (added automatically). */
  quote: string;
  /** Optional host photo; falls back to the host gradient disc. */
  avatarUrl?: string;
  style?: CSSProperties;
}

export function HostNote({ hostName, quote, avatarUrl, style }: HostNoteProps) {
  return (
    <div style={{
      display: 'flex', gap: 14, alignItems: 'flex-start',
      background: 'var(--accent-tint)',
      border: '1px solid var(--accent-border)',
      borderRadius: 'var(--r-card)',
      padding: '17px var(--sp-highlight-pad-x)',
      ...style,
    }}>
      {avatarUrl ? (
        <img src={avatarUrl} alt={hostName} style={{ width: 38, height: 38, borderRadius: '999px', objectFit: 'cover', border: '0.5px solid rgb(var(--cream) / .18)', flexShrink: 0 }} />
      ) : (
        <div style={{ width: 38, height: 38, borderRadius: '999px', background: 'var(--avatar-bg)', flexShrink: 0 }} />
      )}
      <div>
        <p style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--fs-caption2)', color: 'var(--text-soft)', marginBottom: 6 }}>
          A note from {hostName}
        </p>
        <p style={{ fontFamily: 'var(--font-serif)', fontWeight: 400, fontSize: 'var(--fs-quote)', lineHeight: 'var(--lh-quote)', color: 'var(--text)', textWrap: 'pretty' }}>
          &ldquo;{quote}&rdquo;
        </p>
      </div>
    </div>
  );
}

export default HostNote;
